



















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbSelect, mdbIcon, mdbInput } from '@folky-tools/mdbvue';
import { ReferenceSku } from '@/models/references/reference-sku';
import { ReferenceSkuUnitPrice, ReferenceSkuUnitPriceType } from '@/models/references/reference-sku-unit-price';
import { Attribute } from '@/models/references-classification/attribute';
import { AttributeValue } from '@/models/references-classification/attribute-value';

@Component({
    components: { mdbRow, mdbCol, mdbSelect, mdbIcon, mdbInput }
})
export default class EditReferenceSku extends Vue {
    @Prop(ReferenceSku) private sku!: ReferenceSku;
    @Prop(Array) private initialSkuAttributes!: Attribute[];
    @Prop() private showPricePerUOM?: boolean;
    private skuAttributes: Attribute[] = [];
    private skuCopy!: ReferenceSku;
    private price: string = '';
    private discountedPrice: string = '';
    private unitPrice: string = '';
    private unitPriceTypes: any[] = [];
    private skuChangedEventName: string = 'referenceSkuChanged';

    @Watch('initialSkuAttributes')
    private onInitialSkuAttributesChanged(): void {
        this.setSelectedValuesForTheAttributes();
    }

    @Watch('showPricePerUOM')
    private onShowPricePerUOMChanged(): void {
        if (!this.showPricePerUOM) {
            this.unitPriceTypes.find(up => up.selected)!.selected = false;
            this.unitPriceTypes.find(up => up.value === undefined)!.selected = true;
            this.onChangeUnitPriceType(undefined, '...');
        }
    }

    private mounted(): void {
        this.skuCopy = this.sku.clone();
        this.allowToShowAttributeSelectorsToCreateNewSku();

        if (this.sku.price) {
            this.price = this.sku.price.toString();
        } else {
            (this.$refs.price as any).$refs.input.$ci.numberValue = null;
            this.price = '';
        }
        if (this.sku.discountedPrice) {
            this.discountedPrice = this.sku.discountedPrice.toString();
        } else {
            (this.$refs.discountedPrice as any).$refs.input.$ci.numberValue = null;
            this.discountedPrice = '';
        }
        this.unitPriceTypes.push({
            value: undefined,
            text: this.$i18n.t(`common.ellipsis`),
            selected: false
        });
        for (const item in ReferenceSkuUnitPriceType) {
            if (isNaN(Number(item))) {
                this.unitPriceTypes.push({
                    value: item,
                    text: this.$i18n.t(`common.unitOfMeasurement.${item.toString()}`),
                    selected: false
                });
            }
        }
        if (this.sku.unitPrice) {
            this.unitPriceTypes.find(up => up.value === this.sku.unitPrice!.type)!.selected = true;
            if (this.sku.unitPrice.price) {
                this.unitPrice = this.sku.unitPrice.price.toString();
            }
        } else {
            (this.$refs.unitPrice as any).$refs.input.$ci.numberValue = null;
            this.unitPrice = '';
        }
        if (this.skuAttributes.length > 0) {
            this.skuAttributes.forEach(attr => {
                attr.values.forEach(val => (val.selected = false));
            });
            if (this.sku.attributes.length > 0) {
                this.sku.attributes.forEach(skuAttr => {
                    this.skuAttributes.forEach(attr => {
                        if (attr.id === skuAttr.id) {
                            attr.values.find(val => val.id === skuAttr.values[0].id)!.selected = true;
                        }
                    });
                });
            }
        }

        this.$watch('price', (newValue: string, oldValue: string) => {
            this.sku.price = (this.$refs.price as any).$refs.input.$ci.numberValue;
            if (this.sku.price === null || this.sku.price === undefined) {
                (this.$refs.discountedPrice as any).$refs.input.$ci.numberValue = null;
                this.sku.discountedPrice = null;
                this.discountedPrice = '';
            } else {
                const priceNum = (this.$refs.price as any).$refs.input.$ci.numberValue;
                const discountedPriceNum = (this.$refs.discountedPrice as any).$refs.input.$ci.numberValue;
                if (discountedPriceNum !== null && priceNum !== null && discountedPriceNum > priceNum) {
                    (this.$refs.discountedPrice as any).$refs.input.$ci.numberValue = (this.$refs.price as any).$refs.input.$ci.numberValue - 0.01;
                    this.sku.discountedPrice = this.sku.price - 0.01;
                    this.discountedPrice = this.sku.discountedPrice.toString();
                }
            }
            this.$emit(this.skuChangedEventName);
        });

        this.$watch('discountedPrice', (newValue: string, oldValue: string) => {
            this.sku.discountedPrice = (this.$refs.discountedPrice as any).$refs.input.$ci.numberValue;
            const priceNum = (this.$refs.price as any).$refs.input.$ci.numberValue;
            const discountedPriceNum = (this.$refs.discountedPrice as any).$refs.input.$ci.numberValue;
            if (discountedPriceNum !== null && priceNum !== null && discountedPriceNum > priceNum) {
                (this.$refs.discountedPrice as any).$refs.input.$ci.numberValue = (this.$refs.price as any).$refs.input.$ci.numberValue - 0.01;
                this.sku.discountedPrice = this.sku.price! - 0.01;
                this.discountedPrice = this.sku.discountedPrice.toString();
            }
            this.$emit(this.skuChangedEventName);
        });

        this.$watch('unitPrice', (newValue: string, oldValue: string) => {
            this.sku.unitPrice!.price = (this.$refs.unitPrice as any).$refs.input.$ci.numberValue;
            this.$emit(this.skuChangedEventName);
        });
    }

    private onChangeUnitPriceType(value: ReferenceSkuUnitPriceType | undefined, text: string) {
        if (value) {
            if (this.sku.unitPrice) {
                this.sku.unitPrice.type = value;
            } else {
                this.sku.unitPrice = new ReferenceSkuUnitPrice();
                this.sku.unitPrice.type = value;
            }
        } else {
            this.sku.unitPrice = undefined;
            this.unitPrice = '';
        }
        this.$emit(this.skuChangedEventName);
    }

    private onChangeAttributeValue(value: number, text: string) {
        if (value) {
            const attribute = this.skuAttributes.find(attr => attr.values.some(val => val.id === value));
            if (attribute) {
                const skuAttribute = this.sku.attributes.find(attr => attr.id === attribute.id);
                if (skuAttribute) {
                    skuAttribute.values[0].id = value;
                    skuAttribute.values[0].name = text;
                } else {
                    const newAttribute = new Attribute();
                    newAttribute.id = attribute.id;
                    newAttribute.name = attribute.name;
                    newAttribute.values.push(new AttributeValue({ id: value, name: text }));
                    this.sku.attributes.push(newAttribute);
                }
            }
        }

        this.$emit(this.skuChangedEventName);
    }

    private hasChanges(): boolean {
        if (this.sku.id < 1) {
            return true;
        }

        let result =
            this.sku.id !== this.skuCopy.id ||
            this.sku.position !== this.skuCopy.position ||
            (this.sku.code ? this.sku.code : null) !== (this.skuCopy.code ? this.skuCopy.code : null) ||
            this.sku.price !== this.skuCopy.price ||
            this.sku.discountedPrice !== this.skuCopy.discountedPrice;

        if (!result) {
            const skuUnitPrice = this.sku.unitPrice ? this.sku.unitPrice : new ReferenceSkuUnitPrice();
            const skuUnitPriceCopy = this.skuCopy.unitPrice ? this.skuCopy.unitPrice : new ReferenceSkuUnitPrice();

            result = skuUnitPrice.type !== skuUnitPriceCopy.type || skuUnitPrice.price !== skuUnitPriceCopy.price;
        }

        if (!result) {
            const objectsEqual = (o1: any, o2: any): boolean =>
                Object.keys(o1).length === Object.keys(o2).length &&
                Object.keys(o1).every((p: any) => {
                    if (Array.isArray(o1[p]) && Array.isArray(o2[p])) {
                        return arraysEqual(o1[p], o2[p]);
                    }
                    return o1[p] === o2[p];
                });

            const arraysEqual = (a1: any[], a2: any[]) => a1.length === a2.length && a1.every((o, idx) => objectsEqual(o, a2[idx]));

            result = !arraysEqual(
                this.sku.attributes.map(attr => new Attribute(attr).clone()),
                this.skuCopy.attributes.map(attr => new Attribute(attr).clone())
            );
        }

        return result;
    }

    private atLeastOneDataFilledIn(): boolean {
        if (
            this.sku.code ||
            this.sku.price !== null ||
            this.sku.discountedPrice !== null ||
            (this.sku.unitPrice && (this.sku.unitPrice.type || this.sku.unitPrice.price)) ||
            (this.sku.attributes.length > 0 && this.sku.attributes.some(a => a.values.length > 0))
        ) {
            return true;
        }
        return false;
    }

    private setSelectedValuesForTheAttributes() {
        this.skuAttributes = this.initialSkuAttributes.map(a => {
            const attribute = a.clone();

            const skuAttribute = this.sku.attributes.find(x => x.id === attribute.id);
            if (skuAttribute) {
                for (const value of attribute.values) {
                    if (value.id === skuAttribute!.values[0].id) {
                        value.selected = true;
                    }
                }
            }

            return attribute;
        });
    }

    private allowToShowAttributeSelectorsToCreateNewSku() {
        this.skuAttributes = this.initialSkuAttributes.map(a => a.clone());
    }
}
